import { type Reducer } from "redux";
import type { DictionaryLoadable } from "~/app/store/loadableTypes";
import { produce } from "immer";
import {
  FINISH_FETCH_TOPSELLER_PRODUCTS,
  START_FETCH_TOPSELLER_PRODUCTS,
  type TopsellerProductsActions,
} from "~/domains/product/redux/topsellerProducts/actions";

export type TopsellerProductsState = DictionaryLoadable<string[]>;

const initialState: TopsellerProductsState = {};

export const topsellerProductsReducer: Reducer<TopsellerProductsState, TopsellerProductsActions> = (
  state = initialState,
  action,
): TopsellerProductsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case START_FETCH_TOPSELLER_PRODUCTS: {
        const { productCode } = action.payload;
        draft[productCode] = { state: "loading" };
        break;
      }
      case FINISH_FETCH_TOPSELLER_PRODUCTS: {
        const { productCode, topsellerProducts, error } = action.payload;
        draft[productCode] = {
          state: error ? "error" : "loaded",
          data: topsellerProducts.map((product) => product.code),
        };
        break;
      }
    }
  });
};
